var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2501 3.00024H6.74995C5.75537 3.00024 4.80172 3.39523 4.09837 4.09861C3.39502 4.802 3 5.75562 3 6.75019V24.2503C3 25.2449 3.39499 26.1985 4.09837 26.9019C4.80175 27.6052 5.75537 28.0002 6.74995 28.0002H24.2501C25.2446 28.0002 26.1983 27.6053 26.9016 26.9019C27.605 26.1985 28 25.2449 28 24.2503V6.75019C28 5.75562 27.605 4.80197 26.9016 4.09861C26.1983 3.39526 25.2446 3.00024 24.2501 3.00024ZM6.74995 5.50041H24.2501C24.5814 5.50041 24.8994 5.63207 25.1339 5.86633C25.3682 6.10088 25.4998 6.41885 25.4998 6.75019V10.5001L5.49972 10.5004V6.75019C5.49972 6.41885 5.63138 6.10088 5.86564 5.86633C6.10019 5.63207 6.41816 5.5004 6.7495 5.5004L6.74995 5.50041ZM25.5001 13.0005V18.0007H5.49994V13.0005H25.5001ZM24.2503 25.5005H6.75017C6.41884 25.5005 6.10087 25.3689 5.86631 25.1346C5.63205 24.9001 5.50039 24.5821 5.50039 24.2507V20.5006H25.5005V24.2507C25.5005 24.5821 25.3688 24.9 25.1346 25.1346C24.9 25.3689 24.5821 25.5005 24.2507 25.5005H24.2503Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableView);
export default __webpack_public_path__ + "static/media/TableView.36ffd12b7da590af80e9ce231bd98670.svg";
export { ForwardRef as ReactComponent };